import { useGet, UseGetReturnType } from '../../../../api';
import { SystemData } from '../../types/SystemData';
import { USER_MANAGEMENT_BASE_URL } from '../consts';

type ReturnType = Omit<UseGetReturnType<SystemData>, 'data'> & {
    systemData?: SystemData;
};

export const useGetSystemData = (): ReturnType => {
    const { data: systemData, ...rest } = useGet<SystemData>({ url: `${USER_MANAGEMENT_BASE_URL}/systemData` });

    return {
        ...rest,
        systemData
    };
};
